import { render } from "./UserPerformace.vue?vue&type=template&id=3059bf79&scoped=true"
import script from "./UserPerformace.vue?vue&type=script&lang=js"
export * from "./UserPerformace.vue?vue&type=script&lang=js"

import "./UserPerformace.vue?vue&type=style&index=0&id=3059bf79&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3059bf79"]])

export default __exports__